import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  progress: [],
};

export const progressSlice = createSlice({
  name: "Progress",
  initialState,
  reducers: {
    setProgress: (state, action) => {
      state.progress = action.payload;
    },
  },
});

export const { setProgress } = progressSlice.actions;
export const progressReducer = progressSlice.reducer;